module.exports = {
  label: 'Thông tin hàng hóa đặc biệt',
  CLASSNO: 'Loại hàng nguy hiểm (CLASS NO)',
  UNNO: 'Số UN',
  PACKING: 'Loại bao bì hàng hóa',
  EMS: 'Lịch trình khẩn cấp',
  Point: 'Điểm chớp cháy',
  Isolation: 'Cách ly',
  man24: 'Người liên hệ khẩn cấp 24/24',
  tel24: 'Số điện thoại',
  ResponsibleParty: 'Bên chịu trách nhiệm',
  HSCODE: 'Mã HS',
  ContractNbr: 'Số hợp đồng',
  SHIPPER: 'Kích thước (Dài x Rộng x Cao)',
  PickTime: 'Thời gian lấy container',
  SeaPullution: 'Ô nhiễm biển',
  GOH: 'Container treo quần áo',
  Tier: 'Tầng',
  Hanger: 'Số sợi mỗi tầng',
  Ropes: 'Số dây mỗi ống',
  Knots: 'Số mắt mỗi dây',
  ReformCost: 'Chi phí cải tạo',
  Warehouse: 'Kho nhập hàng',
  Reefer: 'Container lạnh',
  humidity: 'Độ ẩm (%)',
  ventilation: 'Lưu lượng thông gió (m3)',
  Business: 'Có cần kiểm dịch không',
  PTI: 'Số ngày làm lạnh trước',
  ContainerYard: 'Điểm nhập container',
  Address: 'Thông tin điểm giao nhận',
  StuffingTime: 'Thời gian đóng hàng',
  DeliverTime: 'Khu vực cảng giao container',
  WarehousingTime: 'Ngày nhập kho',
  DoccutoffTime: 'Ngày chốt đơn',
  CustomsCutoffTime: 'Ngày chốt hải quan',
  CorrectTransportName: 'Tên vận chuyển chính xác',
  SecondarySpecialGoods: 'Loại nguy hiểm phụ',
  GrossWeight: 'Trọng lượng gộp',
  NeatWeight: 'Trọng lượng tịnh',
  OuterPackagingType: 'Loại bao bì ngoài',
  OuterPackagingQuantity: 'Số lượng bao bì ngoài',
  InnerPackagingType: 'Loại bao bì trong',
  InnerPackagingQuantity: 'Số lượng bao bì trong',
  Remark: 'Ghi chú',
  Add: 'Thêm mới',
  Delete: 'Xóa',
  PackingCode: 'Mã bao bì',
  Import: 'Nhập',
  FillIn: 'Liên kết',
  OnlyEnterYN: 'Chỉ được nhập Y hoặc N',
  ThisFieldRequired: 'Nếu loại bao bì ngoài là 4G, ô này bắt buộc phải điền',
  HumidityToolTip: 'Độ ẩm = Phần trăm độ ẩm trong không khí',
  Temp: 'Nhiệt độ',
  VentilationWse: 'Lưu lượng thông gió',
  VgmWeight: 'Trọng lượng VGM',
  dgContactEmail: 'Email liên hệ hàng nguy hiểm',
  dgContactFax: 'Fax liên hệ hàng nguy hiểm',
  bookingNo: 'Số đặt chỗ vận chuyển',
  TemperatureUnit: 'Đơn vị nhiệt độ'
}
